import React, { lazy } from 'react'
import { LazyRoute } from 'Modules'
import { FrontUrls } from 'Constants/FrontUrls'

const GridLazy = lazy(() => import('Src/containers/Common/Grid'))

export const OldGridRoutes = [
	<LazyRoute
		exact
		path={`${FrontUrls.partners}/:page?/:id?`}
		lazyComponent={GridLazy}
		key={FrontUrls.partners}
	/>,
	<LazyRoute
		exact
		path={`${FrontUrls.users}/:page?/:id?`}
		lazyComponent={GridLazy}
		key={FrontUrls.users}
	/>,
	<LazyRoute
		exact
		path={`${FrontUrls.customer_identification}/:page?/:id?`}
		lazyComponent={GridLazy}
		key={FrontUrls.customer_identification}
	/>,
	<LazyRoute
		exact
		path={`${FrontUrls.ast_partner_requests}/:page?/:id?`}
		lazyComponent={GridLazy}
		key={FrontUrls.ast_partner_requests}
	/>,
]
